import { useDispatch, useSelector } from "react-redux";
import DismissibleWarningBanner from "../../../presentational/customerItems/DismissibleWarningBanner";
import getWarningMessage from "./getWarningMessage";
import { dismissWarningBanner } from "../../../../state/modules/savedItems/actions";

const ConnectedDismissibleWarningBanner = props => {
  const dispatch = useDispatch();
  const warningMessage = useSelector(getWarningMessage);

  return (
    <DismissibleWarningBanner
      onDismiss={() => dispatch(dismissWarningBanner())}
      {...{ ...props, warningMessage }}
    />
  );
};

export default ConnectedDismissibleWarningBanner;
